import Vue from 'vue'
import api from '@puzzleapps/shared/src/utils/api'

const state = {
  loaded: false,
  data: {}
}

const getters = {

    getLocalPuzzleState: state => puzzleId => {

        for (let key in localStorage) 
        {
            if (key === 'puzzle-'+puzzleId) 
            {
                let store = JSON.parse(localStorage.getItem(key))

                if (store.completed)
                    return 'completed'
                else
                    return 'started'        
            }
        }
        
        return 'ready'
    },

    getLatestPuzzle: state => {
        let keys = Object.keys(state.data)
        let latest = keys.map(e => { return e }).sort().reverse()[0]
        
        return state.data[latest]
    },

}

const actions = {
    setArchiveFromApi({ commit, state }, clientAppId) {
        
        if (!state.loaded)
        {
            return new Promise((resolve, reject) => {
                api.archive(clientAppId)
                    .then(data => {
                        commit('SET_DATA', data)
                        commit('SET_LOADED', true)
                        resolve()
                    })
            })
        }
    },

  

}

const mutations = {
    SET_DATA(state, data) {
        state.data = data
    },
    
    SET_LOADED(state, loaded) {
        if (process.env.NODE_ENV === 'development') {
            console.log('loaded', loaded)
        }
        state.loaded = loaded
    },

}

export {
    state,
    getters,
    actions,
    mutations,
}